require('intersection-observer');
require('slick-carousel');

(function ($) {

  $('.slick').slick();

  $('.slick-testimonials').slick({
    dots: true,
    adaptiveHeight: true,
    autoplay: true
  });

  // resources nav
  $('.resources-nav__link').on('click', function (e) {
    e.preventDefault();

    var section = $(this).attr('href');

    // hide everything first
    $('#reports, #news-events, #faqs').removeClass('is-visible');

    // remove active class
    $('.resources-nav__item').removeClass('active');

    // add active class to nav item
    $(this).parent().addClass('active');

    // reveal section
    $(section).addClass('is-visible');
  });

  // news and events
  $('#news-events .page-wrap:first-child').removeClass('hidden');

  $('#news-events .load-more').on('click', function () {
    $('#news-events .page-wrap.hidden:first').removeClass('hidden');
  });

  // faqs
  $('.faq__question').on('click', function () {
    $(this).toggleClass('is-toggled').next().slideToggle();
  });

  // leadership carousel
  $('.leadership-trigger').click(function (e) {
    e.preventDefault();
    $('.leadership-trigger').removeClass('active');
    $(this).addClass('active');
    var person = $(this).attr('data-person');
    $('.person').each(function () {
      $(this).hide();
      if ($(this).attr('data-person') == person) {
        $(this).fadeIn();
      }
    });
  });

  $('.accordian-title').click(function () {
    if ($(this).hasClass('active')) {
      $('.accordian-inner').slideUp();
      $('.accordian-title').removeClass('active');
    } else {
      $('.accordian-inner').slideUp();
      $('.accordian-title').removeClass('active');
      $(this).parent().find('.accordian-inner').slideDown();
      $(this).addClass('active');
      $(this).parent().find('.accordian-inner').append($('#gform_wrapper_18'));
      $('#input_18_5').val($(this).text());
    }
  });

  //   if($('.home-row')) {
  //     $(window).on('scroll', function() {
  //       $('.home-row').each(function() {
  //         if(isScrolledIntoView($(this))) {
  //           $(this).addClass('animate');
  //         }
  //       });
  //     });
  //   }

  // function isScrolledIntoView(elem)
  // {
  //   var docViewTop = $(window).scrollTop();
  //   var docViewBottom = docViewTop + $(window).height();

  //   var elemTop = $(elem).offset().top;
  //   var elemBottom = elemTop + $(elem).height();

  //   return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  // }

  /**
   * AOI - Animate on intersection
   *
   * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
   */
  // foreach polyfill
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  const targets = document.querySelectorAll("[data-aoi]");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        entry.target.classList.add('animate');
      }
      // else {
      //   entry.target.classList.remove('animate');
      // }
    });
  }, { rootMargin: '-150px' });

  targets.forEach(target => {
    observer.observe(target);
  });

})(jQuery);